export class AiChatSession {
  constructor ({
    sessionId,
    title,
    date
  }) {
    this.sessionId = sessionId
    this.title = title
    this.date = date
  }
}
